import { UserRole } from '@/__generated__/types';

export const mergeRoles = (role: UserRole, roles: UserRole[]): UserRole[] => {
    // merge role and roles
    const newRoles = [role, ...(roles || [])];
    // remove duplicate roles
    const uniqueRoles = Array.from(new Set(newRoles));
    return uniqueRoles;
};
